import React from 'react';
import LinkCell3 from "./LinkCell3/LinkCell3";
import {useParams} from "react-router-dom";

function LinkToOrgPatients(props) {
    const {medId, orgId, orgName, history} = useParams()
    const url = `${process.env.REACT_APP_URL_PREFIX}/counterAgents/MedCenterOrgList/${medId}/${orgName}/${orgId}/${history}/${props.idArr[0]}`
    return (
        <LinkCell3 linkRoute={url} linkTitle={props.cellContent[props.cellData.show]}
                   editClick={_ => props.cellData.onClick(props.idArr[0])}/>);
}

export default LinkToOrgPatients;